import { IconButton, InputBase, styled } from '@mui/material';

export const Wrapper = styled('div', {
  shouldForwardProp: (prop) => prop !== 'expanded',
})<{ expanded: boolean }>(({ expanded, theme }) => ({
  display: 'flex',
  alignItems: 'center',
  height: '38px',
  borderRadius: '10px',
  border: expanded ? `1px solid ${theme.palette.primary.main}` : `1px solid ${theme.palette.secondary.dark}`,
  background: theme.palette.background.paper,
  overflow: 'hidden',
  transition: 'width 0.22s cubic-bezier(0.4, 0, 0.2, 1), border-color 0.15s ease',
  width: expanded ? '220px' : '38px',
  flexShrink: 0,
}));

export const StyledIconButton = styled(IconButton)({
  padding: '7px',
  flexShrink: 0,
});

export const StyledInput = styled(InputBase)(({ theme }) => ({
  flex: 1,
  fontSize: '13px',
  color: theme.palette.text.primary,
  paddingRight: '4px',
  '& input': {
    padding: 0,
  },
}));
